"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const text_field_styles_1 = require("./text-field-styles");
const tooltip_1 = require("../tooltip/tooltip");
const component_size_1 = require("../../utils/component-size");
const lib_1 = require("use-debounce/lib");
exports.TextField = react_1.forwardRef(function TextField({ form, id, name, onChange, disabled, value, onBlur, onFocus, onKeyDown, startAdornment, endAdornment, onChangeEvent, error = false, type = 'text', autocomplete, inputProps, }, ref) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    // prepare value for MUI component
    value = value !== null && value !== void 0 ? value : '';
    const handleChange = event_callback_hook_1.useEventCallback((e) => {
        if (onChangeEvent !== undefined) {
            onChangeEvent(e);
        }
        if (onChange !== undefined) {
            const value = e.target.value;
            onChange(value !== '' ? value : null);
        }
    });
    const classes = text_field_styles_1.useStyles();
    const inputRef = react_1.useRef(null);
    const [useTooltip, setUseTooltip] = react_1.useState(false);
    const { width } = component_size_1.useComponentSize(inputRef);
    const [debouncedWidth] = lib_1.useDebounce(width, 500);
    react_1.useLayoutEffect(() => {
        setUseTooltip(isEllipsisActive(inputRef));
    }, [value, debouncedWidth]);
    startAdornment = startAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "start" }, startAdornment));
    endAdornment = endAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "end" }, endAdornment));
    const content = (react_1.default.createElement(TextField_1.default, { InputProps: {
            classes,
            startAdornment,
            endAdornment,
        }, inputProps: {
            form,
            ref: inputRef,
            ...inputProps,
        }, className: clsx_1.default({ [classes.disabled]: disabled }), id: id, name: name, ref: ref, disabled: disabled, value: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, error: error, spellCheck: true, fullWidth: true, lang: "cs", type: type, autoComplete: autocomplete }));
    return useTooltip ? (react_1.default.createElement(tooltip_1.Tooltip, { title: value, placement: "top-start", type: "HOVER" }, content)) : (react_1.default.createElement(react_1.default.Fragment, null, content));
});
function isEllipsisActive(e) {
    const current = e.current;
    return current !== null ? current.offsetWidth < current.scrollWidth : false;
}
//# sourceMappingURL=text-field.js.map